<template>
  <div class="device-card skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-title"></div>
    <div class="skeleton-text"></div>
    <div class="skeleton-status"></div>
  </div>
</template>

<script setup>
import { GRADIENTS } from '@/styles/brand'
</script>

<style scoped>
.device-card {
  background: v-bind('GRADIENTS.CARD');
  backdrop-filter: blur(20px);
  border: 3px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.skeleton-image {
  width: 230px;
  height: 240px;
  margin: 0 auto 5px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  height: 20px;
  width: 80%;
  margin: 0 auto 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-text {
  height: 16px;
  width: 60%;
  margin: 8px auto 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-status {
  height: 24px;
  width: 40%;
  margin: 8px auto;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(255,255,255,0.1) 25%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.1) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>